import { render, staticRenderFns } from "./ExpertTeam.vue?vue&type=template&id=6f8babfc&scoped=true&"
import script from "./ExpertTeam.vue?vue&type=script&lang=js&"
export * from "./ExpertTeam.vue?vue&type=script&lang=js&"
import style0 from "./ExpertTeam.vue?vue&type=style&index=0&id=6f8babfc&scoped=true&lang=css&"
import style1 from "./ExpertTeam.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8babfc",
  null
  
)

export default component.exports